<div class="container">
  <div class="row">

    <div class="col-12 mb-4">
      <div class="row">

        <div class="col-12 d-block d-lg-none text-center mb-4">
          <img src="./assets/media/imagenIncio.png" width="50%" alt="home-page-image">
        </div>

        <div class="col-12 col-lg-8">
          <div class="row">

            <div class="col-12">
              <h2 class="text-primary">
                <b>Objetivo</b>
              </h2>
            </div>

            <div class="col-12 mb-4">
              Ofrecer a los clientes del Zorro los beneficios que tienen al tramitar un
              financiamiento de Maltia: crecer su inventario, aumentar su línea de productos y
              sustituir deudas.
            </div>

            <div class="col-12">
              <h2 class="text-primary">
                <b>Beneficios</b>
              </h2>
            </div>

            <div class="col-12 mb-4">
              <ul>
                <li>
                  El mejor costo del mercado
                </li>
                <li>
                  El cliente lo puede usar cuando quiera, las veces que quiera
                </li>
                <li>
                  Sin comisiones por prepago
                </li>
                <li>
                  2% de bonificación en sus compras con Zorro
                </li>
                <li>
                  Sencillo, fácil y rápido
                </li>
              </ul>
            </div>

          </div>
        </div>

        <div class="col-lg-4 d-none d-lg-block text-end">
          <img src="./assets/media/imagenIncio.png" width="50%" alt="home-page-image">
        </div>

      </div>
    </div>

    <div class="col-12 bg-danger text-white mb-4 text-center py-2">
      <h3>El cliente hace crecer su negocio, le ayudamos a cumplir sus sueños</h3>
    </div>

    <div class="col-12">
      <h2 class="text-primary">
        <b>Pasos a seguir</b>
      </h2>
    </div>

    <div class="col-12">
      Darle un pequeño speech al tendero:
    </div>

    <div class="col-12 mb-4">
      <ul>
        <li>
          Haga crecer su negocio con un financiamiento de Maltia. Si le interesa escanee el
          QR de la parte de atrás y lo van a buscar.
        </li>
        <li>
          Que el cliente se registre y listo.
        </li>
      </ul>
    </div>

    <div class="col-12">
      <h2 class="text-primary">
        <b>Speech</b>
      </h2>
    </div>

    <div class="col-12 mb-4">
      Obtenga beneficios exclusivos por ser cliente Zorro, tenga más utilidad en su negocio
      obtenga una bonificación del 2% en sus compras con su línea de crédito Maltia.
    </div>

    <div class="col-12">
      <h2 class="text-primary">
        <b>Meta</b>
      </h2>
    </div>

    <div class="col-12 mb-4">
      Registrar un cliente diario por tienda en la aplicación de Maltia (datos completos e
      INE agregada).
      <br>
      El corte es mensual.
    </div>

    <div class="col-12 bg-third text-white mb-4 text-center py-2">
      <h3>¡Ánimo, podrás ganarte estos premios!</h3>
    </div>

    <div class="col-12 mb-5">
      <div class="row">

        <div class="col-12 col-md-6">
          <div class="row">
            <div class="col-12 text-center">
              2 Pantallas de 32”
            </div>
            <div class="col-12 text-center">
              <img src="./assets/media/premioPantalla.png" alt="Premio 1" class="img-fluid">
            </div>
            <div class="col-12 text-center mb-4">
              90% y 100% de cumplimiento
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="row">
            <div class="col-12 text-center mb-2">
              2 Tabletas Android 10”
            </div>
            <div class="col-12 text-center mb-2">
              <img src="./assets/media/premioTableta.png" alt="Premio 1" class="img-fluid">
            </div>
            <div class="col-12 text-center">
              80% y 90% cumplimiento
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</div>
